import { connect } from 'react-redux';
import {
  getPartnersRequest,
  savePartnerRequest,
  savePartnerDetailsRequest,
  addPartnerDetailsRequest,
  addEditedPartner,
} from './change-partner-actions';
import ChangePartner from '../components/change-partner';

const mapStateToProps = state => ({
  data: state.order.changePartner.data,
  searchData: state.order.changePartner.searchData,
  isLoading: state.order.changePartner.isLoading,
  error: state.order.changePartner.error,
  isSaving: state.order.changePartner.isSaving,
  saveSuccess: state.order.changePartner.saveSuccess,
  lastUsed: state.order.changePartner.lastUsed,
  saveDetailsSuccess: state.order.changePartner.saveDetailsSuccess,
  editedPartners: state.order.changePartner.editedPartners,
});

const mapDispatchToProps = {
  getPartnersRequest,
  savePartnerRequest,
  savePartnerDetailsRequest,
  addPartnerDetailsRequest,
  addEditedPartner,
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangePartner);
